import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { Icon, Loader, Modal } from 'semantic-ui-react';
import TextField from '../../OrderEntry/ui/TextField';
import axios from 'axios';
import { useUserContext } from '../../../context/UserContext';
import PasswordInput from '../../../components/PasswordInput';
import qs from 'qs';

const ChangePasswordContent = styled.div`
  display: flex;
  flex-direction: column;
`;
const TopPart = styled.div`
  padding: 26px 20px 20px 20px;
  border: 1px solid #e5e5ea;
`;
const Close = styled.button`
  display: flex;
  justify-content: flex-end;
  background-color: #fff;
  border: none;
  cursor: pointer;
`;
const ActualContent = styled.div`
  padding: 8px 40px 40px 40px;
`;
const Header = styled.div`
  font-weight: bold;
  font-size: 20px;
  color: #4d4e4d;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 9px;
  margin-top: 45px;
  justify-content: flex-end;
`;

const CancelButton = styled.button`
  background: #ffffff;
  border: 1px solid #e5e5ea;
  box-sizing: border-box;
  border-radius: 5px;
  color: #444444;
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 21px;
  text-align: center;
  width: 174px;
  height: 48px;
  cursor: pointer;
`;
const AddButton = styled.button`
  background: #444;
  border: 1px solid #444;
  box-sizing: border-box;
  border-radius: 5px;
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 21px;
  text-align: center;
  color: #ffffff;
  width: 144px;
  height: 46px;
  cursor: pointer;
`;
interface Props {
  open: boolean;
  onClose: any;
  userId: number;
  confirmPasswordUrl: string;
  changePasswordUrl: string;
  needsClientId?: boolean;
  handleAfterChange?: () => void;
}

const ChangePasswordModal = (props: Props) => {
  const { user } = useUserContext();
  const [loading, setLoading] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState('');
  const [password, setPassword] = useState('');
  const [oldPassword, setOldPassword] = useState('');
  const [confirmPasswordError, setConfirmPasswordError] = useState(false);
  const [oldPasswordVerified, setOldPasswordVerified] = useState(true);
  const [successPopup, setSuccessPopup] = useState(false);

  let regex = /[^a-zA-Z0-9]/g;

  const handleOnBlur = () => {
    if (confirmPassword !== password) {
      setConfirmPasswordError(true);
    } else {
      setConfirmPasswordError(false);
    }
  };
  const handleOnPasswordBlur = async (e: any) => {
    const queryString = getQueryString(e.target.value);
    const { data } = await axios.get(`${props.confirmPasswordUrl}?${queryString}`);
    setOldPasswordVerified(data)
  };
  const onChangePassword = async () => {
    if (
      confirmPasswordError ||
      password === '' ||
      confirmPassword === '' ||
      !regex.test(password) ||
      password.length < 8 ||
      !oldPasswordVerified
    ) {
      return;
    }
    await axios.post(props.changePasswordUrl, {
      oldPassword,
      password,
      userId: props.userId,
    });
    setSuccessPopup(true);
    setTimeout(() => {
      setSuccessPopup(false);
      props.onClose();
    }, 2000);
    props.handleAfterChange && props.handleAfterChange();
  };
  const getQueryString = (password: string) => {
    const queryObject = {
      password,
      userId: props.needsClientId ? undefined : user.id,
      clientId: props.needsClientId ? user.clientId : undefined,
    };
    return qs.stringify(queryObject);
  };
useEffect(() => {

},[oldPasswordVerified])
  return (
    <Modal open={props.open} style={{ width: 496, zIndex: 500 }} onClose={props.onClose}>
      <ChangePasswordContent>
        <TopPart>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Header>Change Password</Header>
            <Close onClick={props.onClose}>
              <Icon name="close" />
            </Close>
          </div>
        </TopPart>
        <ActualContent>
          <div style={{ display: 'flex' }}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              {/* <TextField
                name="currentPassword"
                label="Current Password"
                width="418"
                value={oldPassword || ''}
                onChange={e => {
                  setOldPassword(e.target.value);
                }}
                onBlur={e => handleOnPasswordBlur(e)}
                styles={{
                  input: { paddingLeft: 8, border: '1px solid #33322f', borderRadius: 1 },
                  marginRight: 8,
                }}
              /> */}
              <PasswordInput
                labelText="Current Password"
                onChange={e => {
                  setOldPassword(e);
                }}              
                value={oldPassword || ''}
                onBlur={e => handleOnPasswordBlur(e)}
                isError={!oldPasswordVerified}
                isColor={!oldPasswordVerified}
              />
            </div>
          </div>
          <PasswordInput
            passwordConditions
            labelText="New Password"
            onChange={value => setPassword(value)}
            value={password || ''}
          />
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <PasswordInput
              labelText="Confirm Password"
              isError={confirmPasswordError}
              onChange={value => setConfirmPassword(value)}
              value={confirmPassword || ''}
              onBlur={handleOnBlur}
              isColor={confirmPasswordError}
            />
          </div>
          {successPopup ? (
            <div
              style={{
                padding: 16,
                backgroundColor: '#333',
                color: '#fff',
                borderRadius: 4,
                marginTop: 16,
              }}
            >
              Password succesfully changed!
            </div>
          ) : (
            <ButtonContainer>
              <CancelButton onClick={props.onClose}>Cancel</CancelButton>
              <AddButton disabled={loading} onClick={onChangePassword}>
                {loading ? <Loader style={{ margin: '0 auto' }} size="mini" inline="centered" /> : 'Save'}
              </AddButton>
            </ButtonContainer>
          )}
        </ActualContent>
      </ChangePasswordContent>
    </Modal>
  );
};

export default ChangePasswordModal;
